import Vue from 'vue'

import TableSettings from '@/components/common/table-settings/TableSettings.vue'

import { checkColumns } from '@/components/common/table-settings/CheckColumns'

Vue.component(TableSettings.name, TableSettings)
Vue.mixin(checkColumns)
